var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.308,
    height: 105.516,
    viewBox: "0 0 168.308 105.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2617.146 -5599.784)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2617.646 5688.307h167.308v.594a15.9 15.9 0 01-15.9 15.9h-135.508a15.9 15.9 0 01-15.9-15.9v-.594h0zm19.214-88.023h128.881a7.033 7.033 0 017.033 7.033v80.99h0-142.947 0v-80.99a7.033 7.033 0 017.033-7.033z",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M2637.543 5606.9h127.814v81.407h-127.814zm50.821 87.1h25.873"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2725.163 5633.037a2 2 0 012 2v31.313a1.912 1.912 0 01-1.912 1.912h-47.9a1.912 1.912 0 01-1.912-1.912h0v-31.4a1.912 1.912 0 011.912-1.912h47.812zm-49.726 8.163h51.726m-51.726 8.459h51.726",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.554,
    cy: 4.554,
    r: 4.554,
    transform: "translate(2681.061 5654.034)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6e7e9d",
    d: "M2696.663 5656.136h26.315m-26.315 2.451h26.315m-26.315 2.452h26.315"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.3b3ff55f03ecb4d6433c092bfb797219.svg";
export { ForwardRef as ReactComponent };